import { Route } from "@angular/router";

import { checkIfLoggedInFn } from "../../../core/guards";
import { ManualUnallowedPageComponent } from "./manual-unallowed-page";

export const MANUAL_ROUTES: Route[] = [
  {
    path: "pmo-manual-web",
    canActivate: [checkIfLoggedInFn],
    component: ManualUnallowedPageComponent,
    data: {
      breadcrumb: "topbar.help.entitymanual",
      title: "topbar.help.entitymanual",
    },
  },
  {
    path: "pmo-manual-pdf",
    canActivate: [checkIfLoggedInFn],
    component: ManualUnallowedPageComponent,
    data: {
      breadcrumb: "topbar.help.usermanual",
      title: "topbar.help.usermanual",
    },
  },
];
